
global.ag = ''
global.ar = ''
global.name_area = ''
global.name_ag = ''
global.menu = 1;

//Neo4Tourism

global.title = "Neo4Tourism";
global.wait = 1

global.ar1 = {
  ar: 1,
  ag: 2,
  name_area: "Hauts-de-France",
  gid_area:"FRA.7_1",
  double : 0,
  zoom : 7,
  center : [0, 0],
  perimeterList : [],
  tcf:{2:{},3:{},4:{},5:{}},
  aggList: [
          { value: 2, label: 'Département' },
          { value: 3, label: 'Canton' },
          { value: 4, label: 'Communauté de communes' },
          { value: 5, label: 'Communes' }
      ]
}
global.ar2 = {
  ar: 2,
  ag: 3,
  name_area: "Nord",
  gid_area:"FRA.7.2_1",
  zoom : 8,
  center : [0, 0],
  perimeterList : [],
  tcf:{3:{},4:{},5:{}},
  aggList: [
          { value: 3, label: 'Canton' },
          { value: 4, label: 'Communauté de communes' },
          { value: 5, label: 'Communes' }
      ]
}
global.ar3 = {
  ar: 3,
  ag: 4,
  name_area: "Lille",
  gid_area:"FRA.7_1.1.1",
  zoom : 10,
  center : [0, 0],
  perimeterList : [],
  tcf:{4:{},5:{}},
  aggList: [
          { value: 4, label: 'Communauté de communes' },
          { value: 5, label: 'Communes' }
      ]
}
global.shapes = {
  area1:{2:{}, 3:{}, 4:{}, 5:{}},
  area2:{3:{}, 4:{}, 5:{}},
  area3:{4:{}, 5:{}}
}

global.color1 = [78, 255, 232, 1]
global.color2 = [25, 19, 129, 1]

global.min = 0.15
global.max = 1.85

global.grad = []
global.size = 500

for (let i = 1; i <= global.size; i++) {
    var ibis = i / global.size;
    var r = parseInt(ibis * (global.color2[0] - global.color1[0]) + global.color1[0])
    var g = parseInt(ibis * (global.color2[1] - global.color1[1]) + global.color1[1])
    var b = parseInt(ibis * (global.color2[2] - global.color1[2]) + global.color1[2])
    global.grad[i - 1] = { r, g, b }
}


export function hasTCF(area){
  return (global[area].tcf[global[area].ag][global[area].gid_area] && global[area].tcf[global[area].ag][global[area].gid_area][global.year] && global[area].tcf[global[area].ag][global[area].gid_area][global.year][global.nat])
}

export function getTCFs(area){
  if(!hasTCF(area))
    return null
  return global[area].tcf[global[area].ag][global[area].gid_area][global.year][global.nat]
}

export function getTCF(area, name){
  var TCFs = global[area].tcf[global[area].ag][global[area].gid_area][global.year][global.nat]
  var tcf = 0
  if(TCFs && TCFs.TCFs && TCFs.TCFs.length > 0)
    TCFs.TCFs.forEach(element => {
      if(element.zone === name){
        tcf = element.TCF
      }
    })
  return tcf.toPrecision(6)
}

export function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}

export function rgbToHex(color) {
    return "#" + componentToHex(color.r) + componentToHex(color.g) + componentToHex(color.b);
}

export function Scale(value) {
    var result = (value - global.min) / (global.max - global.min)
    if (result > 1) result = 1
    if (result < 0) result = 0
    return result
}

export function GetColor(TCF) {
    var result = '#888888'
    var index = parseInt(global.size * Scale(TCF))
    if (index === global.size) index = global.size - 1
    result = (rgbToHex(global.grad[index]))
    //console.log(TCF, global.size, index, result, global.grad)

    return result
}

export function GetGrad(color) {
    return color.join(',')
}


global.optionsYE = [
  { value: 2020, label: '2020' },
  { value: 2019, label: '2019' },
  { value: 2018, label: '2018' },
  { value: 2017, label: '2017' },
  { value: 2016, label: '2016' },
  { value: 2015, label: '2015' },
  { value: 2014, label: '2014' },
  { value: 2013, label: '2013' },
]
var optionsNT = [
    { value: 'France', label: 'France' },
    { value: 'United Kingdom', label: 'United Kingdom' },
    { value: 'United States', label: 'United States' },
    { value: 'Belgium', label: 'Belgium' },
    { value: 'Italy', label: 'Italy' },
    { value: 'Spain', label: 'Spain' },
    { value: 'Germany', label: 'Germany' },
    { value: 'Switzerland', label: 'Switzerland' }
]
